import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DurationModule } from '@pipes/duration/duration.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDomainModule } from '@web/app/pipes/translate/translate-domain.module';
import { LoadingModule } from '@web/app/components/loading/loading.module';
import { MatTableModule } from '@angular/material/table';
import { PhoneModule } from '@web/app/pipes/phone/phone.module';
import { LoginAsWineryRoutingModule } from "@web/app/pages/admin/login-as-winery/login-as-winery-routing.module";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { LoginAsWineryComponent } from "@web/app/pages/admin/login-as-winery/login-as-winery.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { HttpClientModule } from "@angular/common/http";
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { WsTooltipModule } from "@web/util/ws-ui/ws-tooltip/ws-tooltip.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";


@NgModule({
  declarations: [LoginAsWineryComponent],
  imports: [
    CommonModule,
    LoginAsWineryRoutingModule,
    LoadingModule,
    TranslateModule,
    DurationModule,
    MatTableModule,
    MatMenuModule,
    MatButtonModule,
    PhoneModule,
    MatIconModule,
    TranslateDomainModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSelectModule,
    FormsModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    WsUiModule,
    MatFormFieldModule,
    MatInputModule,
    WsTooltipModule,
    MatAutocompleteModule
  ]
})
export class LoginAsWineryComponentModule { }
